import apiClient from '../../../services/apiClient';

const BASE = '/patients';

export interface GynecolologicalHistory {
  id?: number;
  patient_id: number;
  menarche_age?: number | null;
  menstrual_pattern?: 'regular' | 'irregular' | null;
  last_menstruation_date?: string | null;
  is_menopausal?: boolean;
  menopausal_age?: number | null;
  pap_date?: string | null;
  pap_result?: string | null;
  mammogram_date?: string | null;
  mammogram_result?: string | null;
  contraceptive_method?: string | null;
  is_sexually_active?: boolean;
  sexual_activity_notes?: string | null;
}

export interface PersonalPathological {
  id?: number;
  patient_id: number;
  condition_name: string;
  icd10_code?: string | null;
  diagnosis_year?: number | null;
  status?: 'active' | 'resolved' | 'chronic' | null;
  severity?: 'mild' | 'moderate' | 'severe' | null;
  current_treatment?: string | null;
  notes?: string | null;
}

export interface FamilyHealthHistory {
  id?: number;
  patient_id: number;
  relative_type?: 'father' | 'mother' | 'sibling' | 'grandparent' | 'child' | 'other' | null;
  condition_name: string;
  icd10_code?: string | null;
  age_at_diagnosis?: number | null;
  severity?: 'mild' | 'moderate' | 'severe' | null;
  notes?: string | null;
}

export const patientHistoryService = {
  // Gynecolological
  getGynecologicalHistory: (patientId: number) =>
    apiClient.get<{ data: GynecolologicalHistory }>(`${BASE}/${patientId}/gynecological-history`).then(r => r.data.data),

  updateGynecologicalHistory: (patientId: number, data: GynecolologicalHistory) =>
    apiClient.put<{ data: GynecolologicalHistory }>(`${BASE}/${patientId}/gynecological-history`, data).then(r => r.data.data),

  // Personal Pathological
  getPersonalPathologicalHistory: (patientId: number) =>
    apiClient.get<{ data: PersonalPathological[] }>(`${BASE}/${patientId}/personal-pathological-history`).then(r => r.data.data || []),

  createPersonalPathological: (patientId: number, data: Omit<PersonalPathological, 'id' | 'patient_id'>) =>
    apiClient.post<{ data: PersonalPathological }>(`${BASE}/${patientId}/personal-pathological-history`, data).then(r => r.data.data),

  updatePersonalPathological: (patientId: number, historyId: number, data: Partial<PersonalPathological>) =>
    apiClient.put<{ data: PersonalPathological }>(`${BASE}/${patientId}/personal-pathological-history/${historyId}`, data).then(r => r.data.data),

  deletePersonalPathological: (patientId: number, historyId: number) =>
    apiClient.delete(`${BASE}/${patientId}/personal-pathological-history/${historyId}`),

  // Family History
  getFamilyHistory: (patientId: number) =>
    apiClient.get<{ data: FamilyHealthHistory[] }>(`${BASE}/${patientId}/family-history`).then(r => r.data.data || []),

  createFamilyHistory: (patientId: number, data: Omit<FamilyHealthHistory, 'id' | 'patient_id'>) =>
    apiClient.post<{ data: FamilyHealthHistory }>(`${BASE}/${patientId}/family-history`, data).then(r => r.data.data),

  updateFamilyHistory: (patientId: number, historyId: number, data: Partial<FamilyHealthHistory>) =>
    apiClient.put<{ data: FamilyHealthHistory }>(`${BASE}/${patientId}/family-history/${historyId}`, data).then(r => r.data.data),

  deleteFamilyHistory: (patientId: number, historyId: number) =>
    apiClient.delete(`${BASE}/${patientId}/family-history/${historyId}`),
};
